module.exports = __webpack_public_path__ + "static/media/hamburger.61a82ec5.svg";